import React from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { PipelineCard, tl } from "./ReportsOverviewExtra";

const MONTHS = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];

export const ProductionLineExtra = ({ stats }) => {
  if (!stats?.monthly) return null;
  const chartData = stats.monthly.map((m) => ({ ...m, name: MONTHS[m.month - 1] }));
  return (
    <div className="space-y-6 mt-6" data-testid="production-line-extra">
      <Card>
        <CardHeader className="pb-2"><CardTitle className="text-base">Aylık Kapı Adedi (Lake / Melamin)</CardTitle></CardHeader>
        <CardContent>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="name" fontSize={12} />
                <YAxis fontSize={11} />
                <Tooltip />
                <Legend />
                <Bar dataKey="lake" name="Lake" stackId="a" fill="#2563eb" />
                <Bar dataKey="melamin" name="Melamin" stackId="a" fill="#16a34a" radius={[3, 3, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="overflow-x-auto mt-4">
            <table className="w-full text-sm" data-testid="production-monthly-table">
              <thead className="bg-gray-50 text-xs text-gray-600">
                <tr><th className="p-2 text-left">Ay</th><th className="p-2 text-right">Lake Adet</th><th className="p-2 text-right">Lake Tutar</th>
                  <th className="p-2 text-right">Melamin Adet</th><th className="p-2 text-right">Melamin Tutar</th><th className="p-2 text-right">Toplam Adet</th></tr>
              </thead>
              <tbody>
                {stats.monthly.map((m) => (
                  <tr key={m.month} className="border-t">
                    <td className="p-2">{MONTHS[m.month - 1]}</td>
                    <td className="p-2 text-right">{m.lake}</td><td className="p-2 text-right">{tl(m.lake_amount)}</td>
                    <td className="p-2 text-right">{m.melamin}</td><td className="p-2 text-right">{tl(m.melamin_amount)}</td>
                    <td className="p-2 text-right font-semibold">{m.lake + m.melamin}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
      <PipelineCard pipeline={stats.pipeline} />
    </div>
  );
};
